<template>
    <div class="developmenter-page" @scroll="bingsrcoll">
        <div class="hidden-sm-and-down"  style="height:100%;">
            <div class="about-content row">
                <div id="miao3" :class="['row','col-md-90',custormAnchor_nav?'show-mao':'hide-mao']">
                    <div class="row col-md-12 about-content-title">
                        <div class="col-md-5">
                            资料下载
                        </div>
                        <!-- <div class="col-md-7 radius-input" style="text-align: right;">
                            <el-input v-model="SearchInformation" placeholder="请输入搜索内容"></el-input>
                            <i class="search-btn el-icon-circle-close" v-show="SearchInformation!=''" @click="goclear"></i>
                            <i class="search-btn el-icon-search" v-show="SearchInformation!=''" @click="gosearch"></i>
                        </div> -->
                    </div>
                    <div class="row col-md-12 ">
                        <div class="col-md-7 ziliao-menu">
                            <div href="#miao1">
                                <span @click.prevent="custormAnchor('miao-1',-1)" :class="[custormAnchor_nav=='miao-1'?'menu-active':'']">全部</span>
                            </div>
                            <div href="#miao1">
                                <span @click.prevent="custormAnchor('miao1',1)" :class="[custormAnchor_nav=='miao1'?'menu-active':'']">Android SDK</span>
                            </div>
                            <div href="#miao2">
                                <span @click.prevent="custormAnchor('miao2',2)" :class="[custormAnchor_nav=='miao2'?'menu-active':'']">Win SDK</span>
                            </div>
                            <div href="#miao3">
                                <span @click.prevent="custormAnchor('miao3',3)" :class="[custormAnchor_nav=='miao3'?'menu-active':'']">Linux SDK</span>
                            </div>
                        </div>
                        <div class="col-md-5 radius-input" style="text-align: right;padding-top: 10px;">
                            <el-input v-model="listQuery.searchName" @keyup.enter.native="gosearch" placeholder="请输入搜索内容"></el-input>
                            <i class="search-btn el-icon-circle-close" v-show="listQuery.searchName!=''" @click="goclear"></i>
                            <i class="search-btn el-icon-search" v-show="listQuery.searchName!=''" @click="gosearch"></i>
                        </div>
                    </div>
                    <!-- {{currentlist}} -->
                    <div class="col-md-12 Information-content">
                        <el-table
                        :data="currentlist"
                        style="width: 100%">
                            <template slot="empty">
                                <div class="empty-tip">
                                    <img src="../assets/img/ic_norecord@3x.png" alt="">
                                </div>
                            </template>
                            <el-table-column
                                prop="name"
                                label="名称"
                                min-width="200">
                            </el-table-column>
                            <el-table-column
                                prop="version"
                                label="版本"
                                width="100">
                            </el-table-column>
                            <el-table-column
                                prop="showSize"
                                label="大小"
                                width="100">
                            </el-table-column>
                            <el-table-column
                                prop="createTime"
                                label="时间"
                                width="160">
                            </el-table-column>
                            <el-table-column
                                prop=""
                                label=""
                                align="center"
                                width="220">
                                <template slot-scope="scope">
                                    <a href="#1" :href="downLoad_url+'/api/developerPlatformFileEntity/downLoadFile/'+scope.row.uuid" :download="scope.row.name"  style="text-decoration: none;font-size:14px;margin-right:30px">
                                        <span class="el-icon-download" style="font-size: 16px;margin-right: -2px;">
                                        </span>
                                        下载
                                    </a>
                                    <el-popover
                                        placement="bottom-start"
                                        title=""
                                        width="400"
                                        trigger="hover"
                                        :content="scope.row.remark?scope.row.remark:'暂无版本说明'">
                                        <a slot="reference" href="#1" style="text-decoration: none;font-size:14px;color:#868686;cursor: default;">
                                            <span class="el-icon-document" style="font-size: 16px;margin-right: -2px;">
                                            </span>
                                            版本说明
                                        </a>
                                    </el-popover>

                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="page-contont">
                        <el-pagination
                            @size-change="getDevelopmenterList"
                            @current-change="getDevelopmenterList"
                            :current-page.sync="listQuery.page"
                            :page-size.sync="listQuery.limit"
                            :page-sizes="[10,20,30]"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="listQuery.total">
                        </el-pagination>
                    </div>
                </div>
            </div>
        <home-foot></home-foot>
        </div>

        <div class="visible-sm-and-down" >
            <div class="mobile-banner">
                <img src="../assets/mobile/servicesupport01_img.png" alt="服务支持">
                <!-- <div class="mobile-banner-title">
                    <div>服务支持</div>
                    <div>SERVICE SUPPORT</div>
                </div> -->
            </div>
            <div class="mobile-content">
                <div class="mobile-content-title">
                    <div>售后服务</div>
                </div>
                <div class="mobile-change-p">
                    <pre class="afterService-content">{{CompanyData.companyInfo.afterService}}</pre>
                    <!-- <div style="margin-top:20px;font-size:14px;">
                        <p>本公司所有售出的机具设备均享受以下售后服务：</p>
                        <p>一、 提供的读写器产品实行12个月内保修，3个月内保换。</p>
                        <p>二、 本公司对所有售出的产品实行终身维护。对于保修保换的产品，甲方须将该产品发回我司指定的维修地点，待查验无误后，进行保修保换。</p>
                        <p>三、 对于客户自行拆装过的产品或因人为原因造成产品损坏，如需修换，则需支付相应的修换费用。卡座以及人为损坏情况需酌情收费。</p>
                        <p style="margin-bottom:20px !important;">四、 提供专用的售后服务热线和电子邮箱地址，对甲方在开发过程中的任何疑难问题进行技术支持。</p>

                        <p>服务热线：400-888-7816 </p>
                        <p>售前咨询分机 316 </p>
                        <p>开发支持分机 333/338</p>
                        <p>服务邮箱：info@decard.com</p>
                        <p>公司总机：0755-86675660/61/62/63</p>
                        <p>公司传真：0755-26629399</p>
                    </div> -->
                </div>
                <img src="../assets/img/Service3_img.jpg" alt="服务支持">
                <div class="visible-sm-and-down" style="font-size: 14px;overflow: hidden;line-height: 24px;margin-top:50px;">
                    <div style="font-weight:600;float: left;font-size: 22px;">联系我们</div>
                    <div style="float: right;color: #00ACF5;font-weight: normal;" >服务热线 : {{CompanyData.companyInfo.hotline || phoneNum}}</div>
                </div>
                <div class="contact-way clearfix" >
                    <div class="col-md-4" v-for="item in CompanyData.companyParamList" style="padding-right:15px;">
                        <img :src="item.picUrl" :alt="item.branchCompanyName" style="width: 100%;height:188px;">
                        <div  class="contact-way-rowdiv">
                            <div class="contact-title">{{item.branchCompanyName}}</div>
                            <div v-if="item.telphone">电话 : {{item.telphone}}</div>
                            <div v-if="item.fax">传真 : {{item.fax}}</div>
                            <div v-if="item.saleTelphone">售前咨询 : {{item.saleTelphone}}</div>
                            <div v-if="item.address">地址 : {{item.address}}</div>
                        </div>
                    </div>
                    <!-- <div class="md-col4" >
                        <img src="../assets/img/home22_img.jpg" alt="深圳总部" style="width: 100%;">
                        <div  class="contact-way-rowdiv">
                            <div class="contact-title">深圳总部</div>
                            <div>总机 : 0755-86675660/61/62/63</div>
                            <div>传真 : 0755-26629399</div>
                            <div>售前咨询 : 0755-86675660/61/62/63转316</div>
                            <div>地址 : 深圳市南山区茶光路文光工业区17栋四楼</div>
                        </div>
                    </div>
                    <div class="md-col4">
                        <div style="text-align: center;">
                            <img src="../assets/img/home23_img.jpg" alt="北京公司" style="width: 100%;">
                            <div  class="contact-way-rowdiv">
                                <div class="contact-title">北京公司</div>
                                <div>电话 : 010-59693060 </div>
                                <div>地址 : 北京市朝阳区百子湾西里402金海商富中心A座1311室</div>
                            </div>
                        </div>
                    </div>
                    <div class="md-col4" style="text-align: right;">
                        <img src="../assets/img/home24_img.jpg" alt="西安研发中心" style="width: 100%;">
                        <div class="contact-way-rowdiv">
                            <div class="contact-title">西安研发中心</div>
                            <div>电话 : 029-68201628 </div>
                            <div>传真 : 029-68201691</div>
                            <div>地址 : 西安市雁塔区沣惠南路16号泰华金贸国际8号楼7层</div>
                        </div>
                    </div> -->
                </div>
                <div class="miao4-content-list clearfix" v-show="MarketCenterInfoList_data.length>0">
                    <div class="miao4-content-list-title">各地营销中心</div>
                    <div class="miao4-content-list-item" v-for="item in MarketCenterInfoList_data" :key="item.agentCode">
                        <div class="miao4-content-list-item-title">{{item.agentAbbr | blankFormat}}</div>
                        <div class="miao4-content-list-item-row clearfix">
                            <div class="miao4-content-list-item-left">联系：</div>
                            <div class="miao4-content-list-item-right">{{(item.userName) | blankFormat}}</div>
                        </div>
                        <div class="miao4-content-list-item-row clearfix">
                            <div class="miao4-content-list-item-left">电话： </div>
                            <div class="miao4-content-list-item-right">{{(item.mobile) | blankFormat}}</div>
                        </div>
                        <div class="miao4-content-list-item-row clearfix" v-if="item.landline">
                            <div class="miao4-content-list-item-left">座机： </div>
                            <div class="miao4-content-list-item-right">{{item.landline}}</div>
                        </div>
                        <div class="miao4-content-list-item-row clearfix">
                            <div class="miao4-content-list-item-left">邮箱： </div>
                            <div class="miao4-content-list-item-right">{{(item.emailAccount) | blankFormat}}</div>
                        </div>
                            <div class="miao4-content-list-item-row clearfix">
                            <div class="miao4-content-list-item-left">地址： </div>
                            <div class="miao4-content-list-item-right">{{item.address | blankFormat}}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div>
            </div>
        <home-foot></home-foot>
        </div>
    </div>
</template>


<script>
import HomeFoot from "@/components/HomeFoot"
import Bus from '../Bus.js';
// import * as Animationjs from "@/assets/js/serviceSVG.js";
export default {
    name: "service",
    components:{
        HomeFoot,
    },
    filters: {
        blankFormat(val) {
            var html = ''
            if (val===undefined||val === null || val === '') {
                html = '-'
            } else {
                html = val
            }
            return html
        }
    },
    created(){

        if(!mercyStore.GETuserInfoEntity()){
            this.$router.push("/");
        }
        setTimeout(function(){
            this.window_height=$(".first-page").height();
        },1000)
    },
    mounted(){
        let _this = this;
        //  获取路由传参 ， 切换custormAnchor_nav
        let get_custormAnchor_nav = this.$route.params.custormAnchor_nav;
        if(get_custormAnchor_nav){
            this.custormAnchor_nav = this.$route.params.custormAnchor_nav;
        }
        Bus.$on('change_service_miao',function(p){
            _this.custormAnchor_nav = p;
            $('.developmenter-page').animate({ scrollTop:(_this.window_height-100) }, 600);
        })
        this.listQuery.type="-1",
        this.custormAnchor_nav = "miao-1"
        this.getDevelopmenterList();
        this.getCenterData()

        axios.get(`${window.$server_config.VUE_APP_WEBSITE_API}outer/company/info?isEn=`+ sessionStorage.getItem("isEn"),).then(response => {
            var res=response.data
            if(res.code=== 200){
                this.CompanyData = res.data
            }else{
                this.$message.error(res.msg?res.msg:'请求有误，请稍后重试')
            }
        }).catch(error=>{
            this.$message.error(res.msg?res.msg:'请求有误，请稍后重试')
        })

    },

    data() {
        return {
            custormAnchor_nav:"miao3",//标签选择
            window_height:900,
            scroll_Value: "0",
            activeNames: ['a1'],
            Information:[             // 原始数据
                {label:"T10&D8 SDK.zip",path:"/static/link/dataDownload/T10&D8 SDK.zip"},
                {label:"T6&D6&Z90&Z9 SDK.zip",path:"/static/link/dataDownload/T6&D6&Z90&Z9 SDK.zip"},
                {label:"t80安装手册.pdf",path:"/static/link/dataDownload/t80安装手册.pdf"},
                {label:"W-I SDK.zip",path:"/static/link/dataDownload/W-I SDK.zip"},
                {label:"RD600 SDK.zip",path:"/static/link/dataDownload/RD600 SDK.zip"},
                {label:"D3 SDK.zip",path:"/static/link/dataDownload/D3 SDK.zip"},
                {label:"p18智能车载pos安装手册.pdf",path:"/static/link/dataDownload/p18智能车载pos安装手册.pdf"},
                {label:"PCSC Reader SDK.rar",path:"/static/link/dataDownload/PCSC Reader SDK.rar"},
                {label:"T6&D6&Z9&Z90读卡器检测工具.zip",path:"/static/link/dataDownload/T6&D6&Z9&Z90读卡器检测工具.zip"},
                {label:"T6-ULC SDK.rar",path:"/static/link/dataDownload/T6-ULC SDK.rar"},
                {label:"RD800 SDK.zip",path:"/static/link/dataDownload/RD800 SDK.zip"},
                {label:"T10SDK1.0.pkg",path:"/static/link/dataDownload/T10SDK1.0.pkg"},
            ],
            InformationList:[],//搜索组
            currentlist:[],//分页组
            jumpPage:"",  //跳页module
            pagination_show:true,
            click_changepage:false,
            window_width:document.body.clientWidth<991?true:false,
            MarketCenterInfoList_data:[],
            listQuery:{
                searchName:"",
                page: 1,
                descs:"update_time",
                type:"-1",
                limit:10,
                total:1000,
            },
            downLoad_url:window.$server_config.VUE_APP_WEBSITE_API,
            CompanyData:"",
        };
    },
    methods:{
        // 折叠窗
        handleChange(val) {
            // console.log(val);
        },

        bingsrcoll(e) {
            this.scroll_Value = e.srcElement.scrollTop;
        },
        custormAnchor(v,nv){
            this.custormAnchor_nav = v;
            this.listQuery.type = nv;
            this.listQuery.page = 1;
            this.listQuery.searchName = '';
            this.getDevelopmenterList();
        },

        change_window_height(){
            // if(document.body.clientWidth<991){
                this.window_height=$(".first-page").height();
                // console.log(this.scroll_Value);
                // console.log(this.window_height);
            // }else{
            //     this.window_height=99999999;
            // }
        },
        goclear(){
            this.listQuery.searchName = "";
            this.listQuery.page = 1;
            this.getDevelopmenterList();
        },
        gosearch(){
            this.listQuery.page = 1;
            this.getDevelopmenterList();
        },
        URLencode(sStr){
            return escape(sStr).replace(/\+/g, '%2B').replace(/\"/g,'%22').replace(/\'/g, '%27').replace(/\//g,'%2F');
        },
        toDownLoad(row){
            window.open(`${window.$server_config.VUE_APP_WEBSITE_API}api/developerPlatformFileEntity/downLoadFile/${this.URLencode(row.uuid)}`)
            return
            axios.get(`${window.$server_config.VUE_APP_WEBSITE_API}api/developerPlatformFileEntity/downLoadFile/${this.URLencode(row.uuid)}`,
               {
                    responseType:'blob'
                }
            ).then((res)=>{
                    var blob = new Blob([res.data])
                    var downloadElement = document.createElement('a');
                　　var href = window.URL.createObjectURL(blob); //创建下载的链接

                　　downloadElement.href = href;
                    // console.log(res.config.params.exportName);
                　　downloadElement.download = row.name;//下载后文件名
                　　document.body.appendChild(downloadElement);
                　　downloadElement.click(); //点击下载
                　　document.body.removeChild(downloadElement); //下载完成移除元素
                　　window.URL.revokeObjectURL(href); //释放掉blob对象

            }).catch(res => {

            })

        },
        getDevelopmenterList(){
            // 获取开发者列表
            //  => => => http://47.105.35.37:41024/api/developerPlatformFileEntity/pageByWebsite?type=1&searchName=1
            let userToken = mercyStore.GETuserInfoEntity().token;
            axios.get(`${window.$server_config.VUE_APP_WEBSITE_API}outer/fileInfo/page`,{params:this.listQuery,headers:{
                        token:userToken
                    }},
            ).then((response)=>{
                var res=response.data
                if(res.code== 200){
                    this.currentlist = res.data.rows
                    this.listQuery.total = res.total
                }else{

                }
            }).catch(res => {

            })
        },
        getCenterData(){//获取各地营销中心数据
            axios.get(`${window.$server_config.VUE_APP_WEBSITE_API}outer/agent/list`).then(response => {
                console.log(response)
                var res=response.data
                if(res.code=== 200){
                    var records=res.data
                    this.MarketCenterInfoList_data=records
                }else{
                    this.$message.error(res.msg?res.msg:'请求有误，请稍后重试')
                }
            })
        }
    },
    watch:{

    },
    computed:{
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

.developmenter-page{
    // margin-top: 60px;
    overflow: auto;

}
.first-page {
    /* background: url("../assets/img/service_title.png") no-repeat; */
    /* background-size: 100% 100%; */
    background-size: 100% auto;
    position: relative;
    height:calc(100% - 60px);
}
#miao1{
    padding-right: 0px;
}
.first-page-titlepart{
    color: #fff;
    text-align: left;
    position: absolute;
    top: 40%;
    left: 15%;
    font-size: 64px;
}
.first-page-title{
    font-size: 48px;
    font-weight: 600;
}
.first-page-titlebottom{
    width:68px;
    border:1.5px solid #fff;
    margin:15px 0;
    border-radius: 5px;
    background: #fff;

}
.first-page-titledesc{
    font-size: 22px;
    font-weight: normal;
}

.ziliao-menu {
  height: 60px;
  line-height: 60px;
}
.ziliao-menu > div {
    display: inline-block;
    margin-right: 25px;
}
.ziliao-menu > div > span {
    cursor: pointer;
    padding: 0;
    height: 100%;
    display: inline-block;
    color: #868686;
}


.about-content{
    // min-height:800px;
    font-size: 14px;
    color: #2C2C2C;
}
.about-content > div {
    min-width: 900px;
    /* max-width: 1600px; */
    margin: 0 auto;
    margin-top: 100px;
    margin-bottom: 100px;
    // min-height: 800px;
}
.about-content-title {
    /* font-size: 40px; */
    font-weight: 600;
    font-size: 32px;
    color: #2C2C2C;
    margin-bottom: 20px;
}
.about-content-title .about-content-secondtitle {
  font-size: 21px;
  color: #a99595;
}
.about-content .search-btn{
    position: absolute;
    top: 17px;
    right: 31px;
    font-size: 18px;
    color: #b37d7d;
    cursor: pointer;
}
.about-content .search-btn:hover{
    color: #3BBDE7;
}
.about-content .search-btn.el-icon-circle-close{
    right: 35px;
}
.about-content .search-btn.el-icon-search{
    right: 10px;
}

/* 常见问题折叠框 */
#miao2 .steps1{
    min-height: 500px;
}
.el-icon-remove-outline{
    position: absolute;
    right: 23px;
    background: #fff;
}
.el-icon-circle-plus-outline{
    position: absolute;
    right: 23px;
    background: #fff;
}

.el-collapse-item__arrow{
    border-bottom: 1px solid #ddd;
}
/* 折叠头 */
.quest-title{
    font-size: 18px;
    font-weight: 600;
}
/* 折叠体 */
.quest-describe{
    padding-top: 20px;
}


.menu-active{
    line-height: 37px;
}

.Information-content{
    margin-top: 15px;
    // height: 450px;
    overflow: hidden;
}
.scroll-body{
    overflow: auto;
    height: 550px;
    // max-height: 670px;
    // min-height: 300px;
}
.scroll-body .Information-list:hover{
    background: #e5e9f2;
}
.Information-list{
    display: inline-block;
    height: 55px;
    line-height: 55px;
    border-bottom: 1px solid #E3E3E3;
    // width: calc(50% - 40px);
    width: 100%;
    // margin-right: 80px;
    margin-top: -5px;
}
.Information-list>span{
    display: inline-block;
    padding-left: 10px;
}
.Information-list:nth-child(2n+2){
    margin-right: 0;
}

.Information-header{
    color: #2C2C2C;
    // background: #f7f1f1;
    font-size: 16px;
    font-weight: 600;
}
.page-contont{
    /* float: right; */
    margin-top: 30px;
    width: 100%;
    text-align: right;
}
.page-contont>div{
    display: inline-block;
    margin-left: 10px;
}
.page-contont .el-icon-arrow-right,.el-icon-arrow-left{
    /* border: 1px solid #333; */
    color: #333;
    cursor: pointer;
}
.page-contont .cant-page{
    color: #ddd;
    /* border-color: #ddd; */
    cursor: not-allowed;
        padding: 3px;
    border: 1px solid #ddd;
}
.addPriceRowRightInput{
    padding: 3px 5px;
    width: 65px;
    display: inline-block;
    text-align: center;
}
#miao4{
    height: auto;
}
.miao4-title{
    font-weight: 600;
    font-size: 32px;
    color: #2C2C2C;
    width: 100%;
    line-height: 32px;
    margin-bottom: 74px;
}
.content-way{
    width: 100%;
}
.contact-way-rowdiv{
    font-size:14px;
    text-align: left;
    margin-top:20px;
    color: #696969;
}
.contact-title{
    font-size: 20px;
    color: #202020;
    font-weight: 600;
}
.contact-way-rowdiv div{
    margin-bottom: 5px;
}
.miao4-content-list{
    width:100%;
    margin: 100px 0 0;
}
.miao4-content-list-title{
    width: 100%;
    font-size: 24px;
    color: #2C2C2C;
    font-weight: 600;
    padding-bottom:18px;
    border-bottom: 1px solid #ECECEC;
}
.miao4-content-list-item{
    float: left;
    width: 32%;
    margin-top: 45px;
    min-height: 190px;
}
.miao4-content-list-item:nth-child(3n+3){
    margin:0 2%;
    margin-top: 45px;
}
.miao4-content-list-item-title{
    font-size: 20px;
    color: #202020;
    font-weight: 600;
    margin-bottom: 10px;
    word-break: break-all;
    text-align: justify;
}
.miao4-content-list-item-row {
    width: 100%;
    font-size: 14px;
    color: #696969;
    line-height: 24px;
}
.miao4-content-list-item-left{
    float: left;
}
.miao4-content-list-item-right{
    float: left;
    width: calc(100% - 50px);
    word-break: break-all;
    text-align: justify;
}
.change-p p{
    margin-bottom: 10px !important;
}
.downloadSpan{
    font-size: 14px;
    color: #3BBDE7;
    cursor: pointer;
}
.downloadSpan:hover{
    color: #22A6D1;
}
/* 移动端 */
.visible-sm-and-down{
    display: flex;
}
.mobile-change-p p{
    color: #2C2C2C;
    margin-bottom:0 !important;
    line-height:28px;
}
.mobile-content img{
    width:100%;
    margin-top:40px;
}


.hidden-sm-and-down {
    display: block !important
  }
  .visible-sm-and-down {
    display: none !important
  }


@media only screen and (max-width:991px) {
    .hidden-sm-and-down {
        display: none !important
    }
    .visible-sm-and-down {
        display: block !important
    }
    .contact-title{
        font-size: 18px;
    }
    .contact-way-rowdiv[data-v-90b5d9ea] {
        font-size: 14px;
        text-align: left;
        margin-top: 16px;
        color: #696969;
    }
    .contact-way-rowdiv div {
        margin-bottom: 2px;
    }
    .mobile-content img[data-v-90b5d9ea] {
        width: 100%;
        margin-top: 32px;
    }
    .miao4-content-list{
        width:100%;
        margin: 50px 0 0;
    }
    .miao4-content-list-title{
        width: 100%;
        font-size: 22px;
        color: #2C2C2C;
        font-weight: 600;
        padding: 0;
    padding-bottom: 10px;
        border-bottom: 1px solid #ECECEC;
    }
    .miao4-content-list-item{
        width: 100%;
        margin-top: 30px;
        min-height: auto;
    }
    .miao4-content-list-item:nth-child(3n+3){
        margin:0 ;
        margin-top: 30px;
    }
    .miao4-content-list-item-title{
        font-size: 18px;
        color: #202020;
        font-weight: 600;
        margin-bottom: 10px;
    }
    .miao4-content-list-item-row {
        width: 100%;
        font-size: 14px;
        color: #696969;
        line-height: 24px;
    }
    .miao4-content-list-item-left{
        float: left;
    }
    .miao4-content-list-item-right{
        float: left;
        width: calc(100% - 50px);
    }
}
    .afterService-content{
        margin-top: 20px;
        font-size: 14px;
        line-height: 30px;
        white-space: pre-wrap;
        white-space: -moz-pre-wrap;
        white-space: -pre-wrap;
        white-space: -o-pre-wrap;
        word-wrap: break-word;
    }
</style>



// WEBPACK FOOTER //
// src/views/developmenter.vue